export var couldNotLoadImage = "Oops! We couldn't retrieve the image";
export var menuDelete = 'Delete';
export var menuEdit = 'Annotate';
//# sourceMappingURL=phrases.js.map